<div class="container mb-2">
    <div class="mt-2 row">
        <div class="d-flex flex-column flex-md-row">
            <div class="d-flex flex-column flex-md-row align-items-center gap-2 my-2">
                <div>
                    <button class="btn" (click)="onExcelExport()">
                        <img src="assets/icon/excel.png" />
                        <span class="mx-1">{{ 'common.excel_export' | translate }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="d-flex flex-column flex-md-row gap-4 col-12">
        <div class="d-flex flex-column gap-4 col-12 col-md-4 col-lg-2">
            <app-vestra-user-search (searchProperties)="setSearchProperties($event)"></app-vestra-user-search>
        </div>

        <div class="col-12 col-md-8 col-lg-10">
            <div class="d-flex flex-wrap justify-content-between my-2 alphabet">
                <button *ngIf="nameStart" class="btn-outline-secondary clear-btn" type="button" (click)="clearNameStartSearch()">
                    <i class="bi bi-x-circle"></i>
                </button>
                <button *ngFor="let letter of alphabet" class="abc-btn btn-outline-secondary" (click)="onLetterSelect(letter)" [ngClass]="{ 'active-letter': letter === nameStart }">
                    {{ letter }}
                </button>
            </div>
            <table id="vestra-user-list" *ngIf="showTable" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border hover mr-2" style="width: 100%"></table>
        </div>
    </div>
</div>
